import {STEP_GENERAL_INFORMATION, STEPS_JOURNEY} from "../public/journey1/definition/business";

const initialState = {
  loading: false,
  steps: STEPS_JOURNEY,
  currentStep:STEP_GENERAL_INFORMATION,
  isFirst:true,
  isLast:false
};

const isLast = (steps, currentStep) => {
  return steps.indexOf(currentStep) === (steps.length - 1);
}

const isFirst = (steps, currentStep) => {
  return steps.indexOf(currentStep) === 0;
}

export function saveStepper(state = initialState, action) {
  switch (action.type) {
      case 'SAVE.RESET_STEPS.SUCCESS':
        return {
          ...state,
          ...initialState,
        }
      case 'SAVE.SET_STEPS.SUCCESS':
          return {
            ...state,
            steps:action.params.steps
          }
        case 'SAVE.SET_NEXT_STEP.SUCCESS':
          let nextStepIndex = state.steps.indexOf(state.currentStep);
          let nextStepCurrentStep = nextStepIndex === -1 || nextStepIndex + 1 === state.steps.length ? null : state.steps[nextStepIndex + 1];
          return {
            ...state,
            previousStep: state.currentStep,
            currentStep: nextStepCurrentStep,
            isFirst: isFirst(state.steps, nextStepCurrentStep),
            isLast: isLast(state.steps, nextStepCurrentStep),
          };
        case 'SAVE.SET_PREVIOUS_STEP.SUCCESS':
          let previousStepIndex = state.steps.indexOf(state.currentStep);
          let previousCurrentStep = previousStepIndex === -1 || previousStepIndex - 1 < 0 ? null : state.steps[previousStepIndex - 1];
          return {
            ...state,
            previousStep: state.currentStep,
            currentStep: previousCurrentStep,
            isFirst: isFirst(state.steps, previousCurrentStep),
            isLast: isLast(state.steps, previousCurrentStep),
          };
        default:
            return state
    }
}
